"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PartnerCompanyAccessSchema", {
    enumerable: true,
    get: function() {
        return PartnerCompanyAccessSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("./base");
const PartnerCompanyAccessSchema = _base.BaseDocument.extend({
    managed_company_id: _zod.z.instanceof(_bson.ObjectId),
    // Suspension toggle; removal sets enabled: false AND deleted_at. Live = enabled + non-deleted.
    enabled: _zod.z.boolean().default(true),
    // Start of the current management period: reset on re-add after removal, stable otherwise.
    created_at: _zod.z.date(),
    updated_at: _zod.z.date(),
    deleted_at: _zod.z.date().or(_zod.z.null()).default(null)
});
